// angular
// 	.module("HeroPRO")
// 	.controller("DeleteLicenseController", deleteLicenseController);

import './deleteLicense.scss';

/* @ngInject */
export default function deleteLicenseController($scope, selectedLicense, LicensesFactory, $rootScope, $uibModalInstance) {
	    const vm = this;
    const license = selectedLicense;
    vm.State = license.State;
    vm.processing = false;
    vm.contentShown = 'deleteLicenseInProgress';
    vm.closeModal = function () {
        let result = false;
        if (vm.contentShown === 'deleteLicenseSuccess') {
            result = true;
        }
        $uibModalInstance.close(result);
    };
    vm.submitDeleteLicense = function () {
        deleteLicense();
    };
    function deleteLicense() {
        vm.processing = true;
        LicensesFactory.deleteLicense(license)
            .then(() => {
						   vm.processing = false;
						   vm.contentShown = 'deleteLicenseSuccess';
       				 });
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/licenses/deleteLicense/deleteLicenseController.js